export enum StagesModules {
	StageTab = 'stage',
	ModuleTab = 'module',
  ListPageNumber = 1,
  List = 'list',
  Add = 'create',
  View = 'view',
  Edit = 'edit'
}
